import { Typography } from '@/components';

export function AdvisorsHeader() {
  return (
    <div>
      <Typography as="h1" size="heading-2" weight="semibold" className="mb-2">
        Our Advisors Network
      </Typography>
    </div>
  );
}
